import React from "react";
import PaperWrapper from "../../../components/ui/paper/paperWrapper";
import TextfieldComponent from "../../../components/ui/textfield/textfieldComponent";
import { t } from "i18next";
import StatusForm from "../../../components/ui/formComponent/statusForm";
import ConfirmButton from "../../../components/ui/button/confirmButton";
import { BoxGapInput } from "../../../components/ui/box/boxGapInput";
import { BoxWrapper } from "../../../components/ui/box/boxWrapper";
import { BoxFormTitleAction } from "../../../components/ui/box/boxFormTitleAction";
import TitleHeaderForm from "../../../components/ui/formComponent/titleHeaderForm";

function VoidReceiptForm({ props }) {
  let {
    handleSubmit,
    onConfirmForm,
    register,
    errors,
    statusButton,
    setStatusButton,
    isSubmitting,
  } = props;
  return (
    <div>
      <form onSubmit={handleSubmit(onConfirmForm)}>
        <BoxWrapper>
          <PaperWrapper props={{ growFull: 1 }}>
            <BoxFormTitleAction>
              <TitleHeaderForm props={{ text: t("void_receipt") }} />
              <StatusForm
                statusButton={statusButton}
                setStatusButton={setStatusButton}
              />
            </BoxFormTitleAction>
            <BoxGapInput>
              <TextfieldComponent
                title={t("void_receipt_name")}
                name="voidReceipt"
                register={register}
                placeholder={t("void_receipt_name_example")}
                errors={errors}
                fullGrid={true}
              />
              <ConfirmButton disabled={isSubmitting} />
            </BoxGapInput>
          </PaperWrapper>
        </BoxWrapper>
      </form>
    </div>
  );
}

export default VoidReceiptForm;
